import { DispatchType } from '../../../@types/redux-types'
import { ContentStateInterface, DropdownOptionSelection } from '../../../@types/types'
import { getGeoCode } from '../../../api/geographicInformationSystem/geographicInformationSystemApi'
import { loadCities, loadQuarters, loadRegions } from '../../../api/geoManualHierarchy/geoManualHierarchyApi'
import { showMessage } from '../../reducers/message/messageFeature'
import { AddressScreenValidationResult, ScreenValidationResult } from '../../../@types/validation-types'
import { InitState } from '../../reducers/root/initialState'
import { getDefaultLogger } from '../../../services/logger/logger'
import { AppDispatch } from '../../../@types/store'
import { hasErrors, runValidation } from '../../../services/validation/editor/runValidation'
import { COUNTRY_CODE_GERMANY } from '../../../utils/geo-utils'
import {
  clearGisServiceRequestPending,
  gisServiceRequest,
  gisServiceRequestCompleted,
  gisServiceSuccess,
  invalidateGeoCoordinates,
  loadCitiesSuccess,
  loadQuartersSuccess,
  loadRegionsSuccess,
  resetValidGeoCoordinates,
  setGisServiceRequestPending,
} from '../../reducers/address/addressFeature'

function validAddressFieldsRelevantToGeoRequest(
  insertionData: ContentStateInterface,
  address: ScreenValidationResult<AddressScreenValidationResult>
) {
  const isFilled = (text: unknown) => text && String(text).length >= 1

  const addressProperties: (keyof ContentStateInterface)[] = ['street', 'city', 'houseNumber', 'postcode']
  const addressFilled = addressProperties.every((property) => isFilled(insertionData[property]))
  return addressFilled && !hasErrors(address, addressProperties)
}
export const queryGeoCodes = () => async (dispatch: DispatchType, getState: () => InitState) => {
  const addressFeature = getState().addressFeature
  const { insertionData } = getState().insertionFeature
  const { address: addressSchema } = getState().flowFeature.flowInformation.validationSchema
  const addressValidationResult = runValidation(insertionData, addressFeature, { address: addressSchema })

  if (validAddressFieldsRelevantToGeoRequest(insertionData, addressValidationResult.address)) {
    dispatch(gisServiceRequest())
    try {
      const geocodes = await getGeoCode(insertionData)
      dispatch(gisServiceSuccess({ coordinates: geocodes }))
    } catch (error) {
      dispatch(showMessage({ message: 'incorrectReverseGeoCode' }))
      dispatch(invalidateGeoCoordinates())
      getDefaultLogger().warn('geoCodes could not be loaded, invalidate geo coordinates', error)
    } finally {
      dispatch(gisServiceRequestCompleted())
    }
  } else {
    dispatch(resetValidGeoCoordinates())
  }
}
let timer: ReturnType<typeof setTimeout>
export const queryGeoCodesDebounced = () => (dispatch: AppDispatch) => {
  clearTimeout(timer)
  dispatch(setGisServiceRequestPending())
  timer = setTimeout(() => {
    dispatch(clearGisServiceRequestPending())
    dispatch(queryGeoCodes())
  }, 500)
}
export const loadManualRegions =
  (id = `${COUNTRY_CODE_GERMANY}`) =>
  async (dispatch: DispatchType) => {
    try {
      const regions = await loadRegions(id)
      dispatch(loadRegionsSuccess({ regions: regions }))
    } catch (error) {
      dispatch(showMessage({ message: 'unknown' }))
    }
  }

export const loadManualCities = (region: DropdownOptionSelection) => async (dispatch: DispatchType) => {
  if (region.value) {
    try {
      const cities = await loadCities(`${COUNTRY_CODE_GERMANY}`, region.value)
      dispatch(loadCitiesSuccess({ cities: cities }))
    } catch (error) {
      dispatch(showMessage({ message: 'unknown' }))
    }
  }
}

export const loadManualQuarters =
  (region: DropdownOptionSelection, city: DropdownOptionSelection) => async (dispatch: DispatchType) => {
    if (region.value && city.value) {
      try {
        const quarters = await loadQuarters(`${COUNTRY_CODE_GERMANY}`, region.value, city.value)
        dispatch(loadQuartersSuccess({ quarters: quarters }))
        return quarters
      } catch (error) {
        dispatch(showMessage({ message: 'unknown' }))
      }
    }
  }
